import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function BackButton({ to, label = "Back", className = "" }) {
  const navigate = useNavigate();
  const onClick = () => {
    if (to) {
      navigate(to);
    } else if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };
  return (
    <button
      type="button"
      onClick={onClick}
      className={`mono inline-flex items-center gap-1.5 border border-foreground bg-background px-3 py-1.5 text-[10px] uppercase tracking-widest transition-all hover:bg-foreground hover:text-background ${className}`}
      data-testid="back-button"
    >
      <ArrowLeft className="h-3.5 w-3.5" />
      {label}
    </button>
  );
}
